import { cva, type VariantProps } from "class-variance-authority";
import { Info } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "./badge";
import {
  MobileTooltip,
  MobileTooltipContent,
  MobileTooltipProvider,
  MobileTooltipTrigger,
} from "./mobile-tooltip";

const byocBadgeVariants = cva(
  "cursor-pointer gap-1.5 rounded-md border-0 bg-gradient-to-br from-emerald-600 to-emerald-800 font-semibold text-white uppercase tracking-wide shadow-md transition-opacity hover:opacity-80",
  {
    variants: {
      size: {
        default:
          "px-2 py-0.5 text-[0.725rem] leading-4 [&>svg]:h-3 [&>svg]:w-3",
        md: "px-2.5 py-1 text-sm [&>svg]:h-3.5 [&>svg]:w-3.5",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

interface ByocBadgeProps extends VariantProps<typeof byocBadgeVariants> {
  className?: string;
  delay?: number;
  showInfoIcon?: boolean;
}

export function ByocBadge({
  className,
  size,
  showInfoIcon = true,
  delay = 350,
}: ByocBadgeProps) {
  return (
    <MobileTooltipProvider delay={delay}>
      <MobileTooltip>
        <MobileTooltipTrigger
          render={
            <Badge className={cn(byocBadgeVariants({ size }), className)} />
          }
        >
          <span>BYOC</span>
          {showInfoIcon && <Info />}
        </MobileTooltipTrigger>
        <MobileTooltipContent>
          <p>
            Bring Your Own Credentials{" "}
            <a
              className="underline hover:no-underline"
              href="https://docs.arcade.dev/home/glossary#bring-your-own-credentials-byoc"
              rel="noopener noreferrer"
              target="_blank"
            >
              Learn more
            </a>
          </p>
        </MobileTooltipContent>
      </MobileTooltip>
    </MobileTooltipProvider>
  );
}
